import { Button } from "components"

type Props = {
  activeTab: string
  setActiveTab: (path: string) => void
}

export function TabNavSales({ activeTab, setActiveTab }: Props) {
  const tabs = [
    { label: "Sales Performance", path: "sales-performance" },
    { label: "Item Performance", path: "item-performance" },
  ]

  return (
    <section className="grow flex items-stretch overflow-x-auto">
      {tabs.map((tab) => (
        <Button
          key={tab.path}
          type="button"
          color="ghost"
          size="sm"
          className={`grow bg-[#3c3c3c] border-y-0 border-x border-white no-animation hover:bg-primary hover:text-black whitespace-nowrap uppercase ${tab.path === activeTab ? "bg-primary text-black" : "text-white"}`}
          onClick={() => setActiveTab(tab.path)}
        >
          {tab.label}
        </Button>
      ))}
    </section>
  )
}
